"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const run_1 = __importDefault(require("./functions/run"));
document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        (0, run_1.default)();
    }
};
